import React from 'react';
import { Navbar } from '@/components/layout/Navbar';
import { Hero } from '@/components/sections/Hero';
import { Intro } from '@/components/sections/Intro';
import { TransitionImage } from '@/components/sections/TransitionImage';
import { Amenities } from '@/components/sections/Amenities';

import { FarmhouseExperience } from '@/components/sections/FarmhouseExperience';
import { ShowcaseImages } from '@/components/sections/ShowcaseImages';
import { PoolSection } from '@/components/sections/PoolSection';
import { Gallery } from '@/components/sections/Gallery';
import { Reviews } from '@/components/sections/Reviews';
import { Location } from '@/components/sections/Location';
import { Footer } from '@/components/sections/Footer';

export default function Home() {
  return (
    <main className="relative min-h-screen bg-background text-foreground selection:bg-accent selection:text-primary">
      <Navbar />
      <Hero />
      <Intro />
      <TransitionImage />
      <Amenities />
      <FarmhouseExperience />
      <ShowcaseImages />
      <PoolSection />
      <Gallery />
      <Reviews />
      <Location />
      <Footer />
    </main>
  );
}
